export const SUPPORT_UNREAD_REFRESH_EVENT = "yb-support-unread-refresh";

export type SupportUnreadRefreshDetail = {
  kind: "message" | "read" | "reconcile";
  ticketId?: string | null;
};

export function formatSupportUnreadCount(count: number) {
  return count > 99 ? "99+" : String(Math.max(0, count));
}

export function supportUnreadLabel(count: number) {
  return `${count} unread YourBarrio Support conversation${count === 1 ? "" : "s"}`;
}

export async function fetchSupportUnreadCount(client: any, audience: "customer" | "business") {
  const { data, error } = await client.rpc("support_unread_count_for_user", { p_audience: audience });
  if (error) throw new Error(error.message || "Failed to load unread Support count");
  const count = Number(data || 0);
  return Number.isFinite(count) && count > 0 ? Math.floor(count) : 0;
}

export async function fetchSupportUnreadTicketIds(
  client: any,
  audience: "customer" | "business",
  ticketIds: string[]
) {
  if (!ticketIds.length) return [];
  const { data, error } = await client.rpc("support_unread_ticket_ids", {
    p_audience: audience,
    p_ticket_ids: ticketIds,
  });
  if (error) throw new Error(error.message || "Failed to load unread Support requests");
  return (Array.isArray(data) ? data : [])
    .map((row: any) => String(row?.ticket_id || ""))
    .filter(Boolean);
}

export function dispatchSupportUnreadRefresh(detail: SupportUnreadRefreshDetail) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent<SupportUnreadRefreshDetail>(SUPPORT_UNREAD_REFRESH_EVENT, { detail }));
}
